import {
  Backdrop, Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider, FormControl, Grid, Input, List, ListItem,
  ListItemText, Paper, Select, TextField, Typography
} from '@material-ui/core';
import CropFreeIcon from '@material-ui/icons/CropFree';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BarkodPopup from '../../components/BarcodePopup';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  content: {
    padding: 0
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  divider: {
    backgroundColor: '#FF9800'
  },
}));
function Todos({ className }) {
  const classes = useStyles();
  const [Loading, setLoading] = useState(false);
  const [todosData, setTodosData] = useState([]);
  const [todosDataFiltered, setTodosDataFiltered] = useState([]);
  const [BayiDataList, setBayiDataList] = useState([]);   // API'den gelen tüm kayıtlar
  const [BayiFilterList, setBayiFilterList] = useState([]);  // Tekilleştirilmiş ve sıralanmış liste
  const [SelectedBayi, setSelectedBayi] = useState("*");  // Başlangıçta *
  const [depoAdresi, setDepoAdresi] = useState("");
  const [bayiUrunList, setBayiUrunList] = useState([]);
  const [bayiUrunListPopUp, setBayiUrunListPopUp] = useState(false);
  const [BayiLoading, setBayiLoading] = useState(false);
  const [DepoTipi, setDepoTipi] = useState("-1");
  const [Aciklama, setAciklama] = useState("");
  const [IslemTipi, setIslemTipi] = useState("3");
  const [openBarkod, setOpenBarkod] = useState(false);
  const [Barkod, setBarkod] = useState("");
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");

  const [Sofor, setSofor] = useState("");
  const [Plaka, setPlaka] = useState("");
  const SessionUser = getUser();

  useEffect(() => {
    setBayiLoading(true);
    axios.get('/GetArtemisUrunKabulBayiler/' + SessionUser.ServiceShopId).then((response) => {
      const Deger = response.data;
      if (Deger.length === 0) {
        setBayiDataList([]);
        setBayiFilterList([]);
      } else {
        setBayiDataList(Deger);

        // BAYI ve BAYI_ACIKLAMA ile tekil liste oluştur
        const uniqueBayilerMap = new Map();
        Deger.forEach(d => {
          if (d.BAYI && !uniqueBayilerMap.has(d.BAYI)) {
            uniqueBayilerMap.set(d.BAYI, d.BAYI_ACIKLAMA);
          }
        });

        const uniqueSortedBayiler = Array.from(uniqueBayilerMap.entries())
          .sort((a, b) => a[1].localeCompare(b[1]));

        setBayiFilterList(uniqueSortedBayiler);
      }
      setBayiLoading(false);
    }).catch(() => {
      setBayiLoading(false);
    });
  }, [SessionUser.ServiceShopId]);




  const DepoTipihandleChange = (event) => {
    setDepoTipi(event.target.value);
  }
  const handleChangeAciklama = (event) => {
    setAciklama(event.target.value);
  }
  const handleChangeSofor = (event) => {
    setSofor(event.target.value);
  }
  const handleChangePlaka = (event) => {
    setPlaka(event.target.value);
  }
  const IslemTipihandleChange = (event) => {
    setIslemTipi(event.target.value);
  }
  const handleBarkodClose = async (barkod) => {

    setOpenBarkod(false);
    setBarkod(barkod);

    if (barkod.length === undefined) {
      setUyari("Barkod okunamadı.Lütfen tekrar deneyiniz!...");
      setOpen(true);
      return;
    }

    if ([18, 20, 22, 24].indexOf(barkod.length) === -1) {
      setUyari("Hatalı barkod formatı.Barkod okunamadı.Lütfen tekrar deneyiniz!...");
      setOpen(true);
      return;
    }

    setLoading(true);
    axios.get('/GetArtemisUrunKabul/' + SessionUser.ServiceShopId + '/' + barkod.replaceAll('/', '') + '/' + DepoTipi).then((response) => {
      const Deger = response.data;
      if (Deger.length === 0) {
        setTodosData([]);
        setTodosDataFiltered([]);
      } else {
        setTodosData(Deger);
        var bayi = "";
        var filteredDeger = Deger.slice();
        if(SelectedBayi !== "*"){
          bayi = SelectedBayi.split(" ")[0];
          filteredDeger = Deger.filter(d => d.BayiKodu === bayi);
        }    
        setTodosDataFiltered(filteredDeger);
      }
      setLoading(false);
    })
  }

  const MerkezeGonderKabul = (log) => {
    var Uyari = log.FisNo + " fişiniz  " + Barkod + " barkodu ile kabul edilecektir.Devam etmek istediğinizden emin misiniz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => MerkezeGonderKabulEvet(log)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }


  const MerkezeGonderKabulEvet = (log) => {
    setLoading(true);
    const data = {
      BIRIM_KODU: SessionUser.ServiceShopId,
      FIS_NO: log.FisNo,
      DURUM: IslemTipi || 0,
      OKUNAN_BARKOD: Barkod || '',
      USER_ID: SessionUser.OrganizationUserId,
      ACIKLAMA: Aciklama || '',
      SOFOR: Sofor || '',
      PLAKA: Plaka || ''
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisUrunKabul', data, config).then((response) => {
      setLoading(false);
      const res = response.data;
      if (parseInt(res.ErrorCode) !== 0) {
        setUyari(res.ErrorDescription);
        setOpen(true);
      } else {
        setUyari("İşleminiz Başarı ile gerçekleştirildi!...");
        setOpen(true);
        // setIslemTipi(""); // İşlem tipinin en son seçilen değerinin devam etmesi için yorum satırına alındı.
        setBarkod("");
        setTodosData([]);
        setTodosDataFiltered([]);
      }
    })
  };


  const handleSorgula = () => {
    const filtered = BayiDataList.filter(d => (d.BAYI === SelectedBayi || SelectedBayi === "*") && (DepoTipi === "-1" || d.DEPO_TIPI === DepoTipi) && (d.KABUL_DURUM_ID === IslemTipi));

    // Müşteri bazlı gruplama
    const musteriGruplari = {};
    filtered.forEach(item => {
      if (!musteriGruplari[item.MUSTERI]) {
        musteriGruplari[item.MUSTERI] = [];
      }
      musteriGruplari[item.MUSTERI].push(item);
    });

    // Grupları diziye çevir ve ürün sayısına göre sırala
    const sortedGruplar = Object.values(musteriGruplari)
      .sort((a, b) => b.length - a.length)
      .map(grup =>
        grup.sort((a, b) => a.KUL_MODEL_KODU.localeCompare(b.KUL_MODEL_KODU, undefined, { numeric: true }))
      );

    // Düz liste haline getir
    const sorted = sortedGruplar.flat();

    setBayiUrunList(sorted);

    if (SelectedBayi === "*") {
      setDepoAdresi("");
    } else {
      const ilgiliBayiUrun = filtered.find(d => d.BAYI === SelectedBayi);
      setDepoAdresi(ilgiliBayiUrun ? ilgiliBayiUrun.DEPO_ADRES : "");
    }

    setBayiUrunListPopUp(true);
  };



  const handleBarkodOpen = () => {
    setOpenBarkod(true);
  }

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {window.navigator.onLine &&
        <div className={clsx(classes.root, className)}>
          <Card>
            <CardHeader title={'Ürün Kabul'} />
            <Divider />
            {
              Loading ?
                <Backdrop className={classes.backdrop} open={Loading}>
                  <CircularProgress color="inherit" />
                </Backdrop>
                : <div></div>
            }
            <CardContent className={classes.content}>
              <form
                className={clsx(classes.root, className)}>
                <div className={classes.fields}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                      fullWidth
                      native
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={DepoTipi}
                      onChange={DepoTipihandleChange}
                    >
                      <option aria-label="None" value="-1" >Tümü</option>
                      <option value={0}>Ortak Depo</option>
                      <option value={1}>Bayi Depo</option>
                      <option value={2}>ADD Depo</option>
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.fields}>
                  <Grid container alignItems="center">
                    <Grid item xs={8}>
                      <FormControl variant="outlined" fullWidth>
                        <Select
                          native
                          value={SelectedBayi}
                          onChange={(e) => { setSelectedBayi(e.target.value); 
                            var bayi = "";
                            var filteredDeger = todosData.slice();
                            const seciliBayi = e.target.value;
                            if(seciliBayi !== "*"){
                              bayi = seciliBayi.split(" ")[0];
                              filteredDeger = todosData.filter(d => d.BayiKodu === bayi);
                            }    
                            setTodosDataFiltered(filteredDeger);
                          }}
                          disabled={BayiLoading}
                        >
                          {BayiLoading ? (
                            <option>Yükleniyor...</option>
                          ) : (
                            <>
                              <option value="*">Tümü</option>
                              {BayiFilterList?.map((bayi, index) => (
                                <option key={index} value={bayi[0]}>
                                  {bayi[0]}
                                </option>
                              ))}
                            </>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                        style={{ marginLeft: 8 }}
                        onClick={() => {
                          handleSorgula();
                        }}
                      >
                        Sorgula
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.fields}>
                  <TextField
                    label={"Şöför"}
                    name="Sofor"
                    fullWidth
                    value={Sofor}
                    onChange={handleChangeSofor}
                    variant="outlined"
                  />
                </div>
                <div className={classes.fields}>
                  <TextField
                    label={"Plaka"}
                    name="Plaka"
                    fullWidth
                    value={Plaka}
                    onChange={handleChangePlaka}
                    variant="outlined"
                  />
                </div>
                <div className={classes.fields}>
                  <FormControl variant="outlined">
                    <Select
                      fullWidth
                      native
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={IslemTipi}
                      onChange={IslemTipihandleChange}
                    >
                      <option aria-label="None" value="" >İşlem Seçiniz!...</option>
                      <option value={1}>Ürün Kabul Bekliyor</option>
                      <option value={2}>Ürün Peronda</option>
                      <option value={3}>Kabul Edildi</option>
                      <option value={4}>Kargo Degisim</option>
                      <option value={5}>Bod Iade</option>
                      <option value={6}>Bayi Iade</option>
                      <option value={7}>Bölge Iade</option>
                      <option value={8}>Müsteriye Çikis</option>
                      <option value={9}>Dna Iade</option>
                      <option value={10}>Iade için lojistige teslim edildi</option>
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.fields}>
                  <TextField
                    label={"Açıklama"}
                    name="Aciklama"
                    multiline
                    rows={2}
                    fullWidth
                    value={Aciklama}
                    onChange={handleChangeAciklama}
                    variant="outlined"
                  />
                </div>
                <div className={classes.fields}>
                  <Paper
                    className={classes.search}
                    elevation={1}>
                    <CropFreeIcon
                      onClick={handleBarkodOpen}
                      className={classes.searchIcon} />
                    <Input
                      className={classes.searchInput}
                      disableUnderline
                      value={Barkod}
                      // onChange={event => { setFilter(event.target.value) }}
                      placeholder={"Ürün Barkodunu Okutunuz!..."}
                    />
                  </Paper>
                </div>
              </form>
            </CardContent>
            <CardContent className={classes.content}>
              <List className={classes.root}>
                {todosDataFiltered.map(log => (
                  <div key={log.FisNo}>
                    <ListItem alignItems="flex-start">
                      <ListItemText>
                        <Typography variant="body1" gutterBottom>
                          <b>FişNo-Durum : </b>
                          {log.FisNo}-{log.Durum}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Randevu : </b>
                          {log.Randevu}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Teknisyen : </b>
                          {log.Teknisyen}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Müşteri : </b>
                          {log.Musteri}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>BayiKodu : </b>
                          {log.BayiKodu}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Bayi : </b>
                          {log.Bayi}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Marka : </b>
                          {log.Marka}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>Model : </b>
                          {log.Model}
                        </Typography>
                        <Divider variant="inset" component="li" />
                        <Typography variant="body1" gutterBottom>
                          <b>GelisYeri : </b>
                          {log.GelisYeri}
                        </Typography>
                        <Typography variant="body1" gutterBottom className={classes.fields}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => MerkezeGonderKabul(log)}
                            className={classes.submitButton}
                            endIcon={<SendIcon>Gonder</SendIcon>}
                          >
                            {"Gönder"}
                          </Button>
                        </Typography>
                      </ListItemText>
                    </ListItem>
                    <Divider className={classes.divider} />
                  </div>
                ))}
              </List>
            </CardContent>

            <BarkodPopup
              onClose={handleBarkodClose}
              open={openBarkod}
              ScanTime={0}
              CallScreen={0}
            />

            <Dialog
              open={bayiUrunListPopUp}
              onClose={() => setBayiUrunListPopUp(false)}
              maxWidth="md"
              fullWidth>
              <DialogTitle>
                {SelectedBayi !== "*" ? `${SelectedBayi} Ürünleri` : "Tüm Bayi Ürünleri"}
                {depoAdresi && (
                  <Typography variant="subtitle2" color="textSecondary">
                    {depoAdresi ? depoAdresi : ''}
                  </Typography>
                )}
              </DialogTitle>
              <DialogContent>
                {bayiUrunList.length === 0 ? (
                  <Typography variant="body1">{'Bu bayiye ait ürün bulunamadı.'}</Typography>
                ) : (
                  <List>
                    {bayiUrunList.map((urun, index) => (
                      <ListItem key={index} divider>
                        {/* <ListItemIcon>
                          <CategoryIcon color="primary" />
                        </ListItemIcon> */}
                        <ListItemText
                          primary={`${urun.KUL_MODEL_KODU} - ${urun.MODEL}`}
                          secondary={
                            <>
                              {`Fiş No: ${urun.FIS_NO} - Müşteri: ${urun.MUSTERI.length > 25 ? urun.MUSTERI.substring(0, 25) + '...' : urun.MUSTERI}`}
                              <br />
                              {`Randevu: ${urun.RANDEVU || '-'}`}
                            </>
                          } />
                      </ListItem>
                    ))}
                  </List>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setBayiUrunListPopUp(false)} color="primary">{'Kapat'}</Button>
              </DialogActions>
            </Dialog>


          </Card>
        </div>
      }
    </div>
  );
}

Todos.propTypes = {
  className: PropTypes.string
};

export default Todos;
